import React from 'react'
import { Image, ImageProps } from '@chakra-ui/react'

interface LazyLoadImgProps extends Omit<ImageProps, 'src'> {
  src: string
  alt?: string
  width?: number | string
  height?: number | string
  style?: React.CSSProperties
  borderRadius?: string | number
  objectFit?: React.CSSProperties['objectFit']
}

/**
 * Image with native lazy loading (loading="lazy").
 * Uses the browser’s built-in lazy loading so images stay stable on scroll
 * and interaction (no flicker from third-party visibility re-checks).
 */
const LazyLoadImg: React.FC<LazyLoadImgProps> = ({
  src,
  alt,
  width,
  height,
  style,
  borderRadius,
  objectFit,
  ...rest
}) => {
  return (
    <Image
      src={src}
      alt={alt ?? ''}
      width={width ?? '100%'}
      height={height ?? '100%'}
      loading="lazy"
      style={style}
      borderRadius={borderRadius}
      objectFit={objectFit}
      {...rest}
    />
  )
}

export default LazyLoadImg
